<style lang="scss" scoped>
.suggest {
  display: flex;

  position: relative;

  width: 100%;
  height: 100%;

  align-items: center;

  input {
    display: block;

    padding: 0;

    outline: none;

    flex: 1;

    font-size: 0.34rem;

    text-indent: 0;
    &::placeholder {
      color: #999;
    }
  }
}

.search-asso {
  position: absolute;
  top: 0;
  z-index: 1;

  width: 100%;
  max-height: 100%;
  padding: 0 0.21rem 0 0.25rem;

  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #ddd;

  overflow-x: hidden;
  overflow-y: auto;

  li {
    height: 0.78rem;

    border-bottom: 1px dashed #ddd;

    font-size: 0.3rem;
    line-height: 0.78rem;

    cursor: pointer;

    &:last-child {
      border: 0 none;
    }
  }
}
</style>

<template>
  <div class="suggest">
    <input
      ref="sugInput"
      v-model="inputValue"
      :placeholder="placeholder"
      class="form-item"
      :maxlength="maxlength"
      @keyup.stop.prevent="search"
      @input.stop.prevent="search"
      @click.stop="search"
    />
    <mc-mask
      v-if="data.initSuggest"
      :show="showAssoWords"
      :show-mask="false"
      :target="data.container"
      :top="maskTop"
      @clickMask="showAssoWords = false"
    >
      <ul
        ref="suggestWrapper"
        class="search-asso"
        :style="{
          left: assoStyle.left,
          width: assoStyle.width
        }"
      >
        <li
          v-for="(word, index) in suggestWords"
          :key="index"
          @click.prevent.stop="selectWord(word, index)"
          v-html="highlight(word)"
        ></li>
      </ul>
    </mc-mask>
  </div>
</template>

<script>
import mcMask from '@/common/widgets/mask'
// import debounce from 'lodash/debounce'
import { API } from '@/api'
export default {
  components: { mcMask },
  // eslint-disable-next-line vue/require-prop-types
  props: ['placeholder', 'data', 'maxlength', 'initValue'],
  data() {
    return {
      inputValue: '',
      suggestWords: [],
      showAssoWords: false,
      assoStyle: {
        left: 0,
        width: 0
      },
      maskTop: 0
    }
  },
  watch: {
    inputValue(val) {
      if (val === '') {
        this.showAssoWords = false
      }
      this.$emit('update:inputValue', val)
    }
  },
  mounted() {
    this.calPos()
    this.init()
  },
  activated() {
    this.init()
  },
  methods: {
    init() {
      this.tickData = {
        is_suggest: 0,
        keyword: '',
        suggest_word: '',
        suggest_pos: -1
      }
    },
    search() {
      this.debounce(async () => {
        if (!this.inputValue) {
          return
        }
        const key = this.inputValue
        const params = {
          keyword: key,
          type: this.data.type
        }
        this.calPos()
        try {
          const words = await API.newReqGood.getNewGoodSuggest(params)
          this.suggestWords = words.length ? words : []
          this.showAssoWords = !!words.length
        } catch (e) {
          console.log(e)
        }
      }, 300)
    },
    debounce(fn, delay) {
      let timeout = null
      return function () {
        const context = this
        const args = arguments
        if (timeout) clearTimeout(timeout)
        timeout = setTimeout(() => {
          fn.apply(context, args)
        }, delay)
      }
    },
    selectWord(word, index) {
      // 更新tick数据
      this.tickData = {
        is_suggest: 1,
        keyword: encodeURIComponent(this.inputValue),
        suggest_word: encodeURIComponent(word),
        suggest_pos: index
      }
      this.inputValue = word
      this.showAssoWords = false
    },
    highlight(word) {
      const key = this.inputValue
      return (
        word && word.replace(key, `<span style='color: #0DAF52;'>${key}</span>`)
      )
    },
    calPos() {
      setTimeout(() => {
        const rect = this.$el.getBoundingClientRect()
        const container = (
          (this.data.container
            ? document.querySelector(this.data.container)
            : document.body) || document.body
        ).getBoundingClientRect()
        this.maskTop = Math.round(rect.top + rect.height - container.top)
        this.assoStyle.left = rect.left - container.left + 'px'
        this.assoStyle.width = rect.width + 'px'
      }, 100)
    },
    fetchTickData() {
      // 非推荐词，记录输入框值
      if (!this.tickData.is_suggest) {
        this.tickData.keyword = encodeURIComponent(this.inputValue)
      }
      return this.tickData
    }
  }
}
</script>
